var render = function render(){var _vm=this,_c=_vm._self._c;return _c('as-modal',{staticClass:"bankAlert",attrs:{"title":"Alert"},on:{"close":function($event){return _vm.$emit('close', $event)}}},[_c('p',[_vm._v("Please select atleast one bank!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }